import {
  CompassAPIMultiSeriesChartData,
  getCompassAPIChartData,
  getMultipleLineChartProps,
} from '../utils/compass'
import type { BaseContext } from './'
import { CommonChartConfig } from './common'

export namespace TechDisruption {
  export namespace Exposures {
    const CONTEXT_ID = 'equity:tech_disruption:exposures'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart:
        | 'historical_sector_exposures'
        | 'historical_faangm_exposures'
        | 'historical_sector_exposures_value'
        | 'historical_faangm_exposures_value'
        | 'historical_sector_exposures_growth'
        | 'historical_faangm_exposures_growth'
      context: typeof CONTEXT_ID
      title: string
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) =>
        getMultipleLineChartProps(Context, {
          convertToPercentages: Array(data.data.length).fill(true),
          chartTitle: config.title,
        })(config, data),
    }
  }

  export namespace ComparisonExposures {
    const CONTEXT_ID = 'equity:tech_disruption:comparison_exposures'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart: 'exposures_index_weighted' | 'exposures_equal_weighted'
      context: typeof CONTEXT_ID
      title: string
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) =>
        getMultipleLineChartProps(Context, {
          convertToPercentages: Array(data.data.length).fill(true),
          chartTitle: config.title,
        })(config, data),
    }
  }

  export namespace Returns {
    const CONTEXT_ID = 'equity:tech_disruption:returns'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart:
        | 'relative_russell_value_growth'
        | 'fama_french_value'
        | 'relative_pb_fama_french'
        | 'value_wrong_side_history_index_weighted'
        | 'value_wrong_side_history_equal_weighted'
        | 'enhanced_and_value_returns'
      context: typeof CONTEXT_ID
      title: string
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) =>
        getMultipleLineChartProps(Context, {
          convertToPercentages: Array(data.data.length).fill(true),
          chartTitle: config.title,
        })(config, data),
    }
  }
}
